var products_on_page;
var next_url;


$(document).ready(function(){
    products_on_page = $('.jea-product-on-page');
    next_url = products_on_page.data('next-url');
    console.log("INITIAL:"+next_url);

    $('#load-more__msg').hide();
// lps
    // jea edited oct 10, 2021
    $("#lps").change(function(){
        let c = $("#lps option:selected").val();
        jea_lps(c);
    });

    $("#euphyllia").change(function(){
        let c = $("#euphyllia option:selected").val();
        jea_lps(c);
    });

    $("#meat-corals").change(function(){
        let c = $("#meat-corals option:selected").val();
        jea_lps(c);
    });

    $("#mushroom").change(function(){
        let c = $("#mushroom option:selected").val();
        jea_lps(c);
    });

    $("#soft-coral").change(function(){
        let c = $("#soft-coral option:selected").val();
        jea_lps(c);
    });

    $("#louis-s-wellso-trachy-wonderland").change(function(){
        let c = $("#louis-s-wellso-trachy-wonderland option:selected").val();
        jea_lps(c);
    });

    $("#invertebrates").change(function(){
        let c = $("#invertebrates option:selected").val();
        jea_lps(c);
    });

    $("#sps").change(function(){
        let c = $("#sps option:selected").val();
        jea_lps(c);
    });

    $("#anemones").change(function(){
        let c = $("#anemones option:selected").val();
        jea_lps(c);
    });

    $("#scoly").change(function(){
        let c = $("#scoly option:selected").val();
        jea_lps(c);
    });

    $("#fish").change(function(){
        let c = $("#fish option:selected").val();
        jea_lps(c);
    });

    $("#inverts").change(function(){
        let c = $("#inverts option:selected").val();
        jea_lps(c);
    });
    // jea end

    $("#jea-acans").click(function(){
        jea_lps("ACANS");
        products_on_page = $('.jea-product-on-page');
        next_url = products_on_page.data('next-url');
        console.log(next_url);
    });

    $("#jea-alveopora").click(function(){
        jea_lps("ALVEOPORA");
    });

    $("#jea-blasto").click(function(){
        jea_lps("BLASTO");
    });

    $("#jea-bubble-coral").click(function(){
        jea_lps("BUBBLECORAL");
    });

    $("#jea-candy-cane").click(function(){
        jea_lps("CANDYCANE");
    });

    $("#jea-chalice").click(function(){
        jea_lps("CHALICE");
    });

    $("#jea-duncan").click(function(){
        jea_lps("DUNCAN");
    });

    $("#jea-echinata").click(function(){
        jea_lps("ECHINATA");
    });

    $("#jea-elegance").click(function(){
        jea_lps("ELEGANCE");
    });

    $("#jea-favia").click(function(){
        jea_lps("FAVIA");
    });

    $("#jea-fox-coral").click(function(){
        jea_lps("FOXCORAL");
    });

    // $("#jea-fungia").click(function(){
    //     jea_lps("FUNGIA");
    // });

    $("#jea-galaxea").click(function(){
        jea_lps("GALAXEA");
    });

    $("#jea-goniopora").click(function(){
        jea_lps("GONIOPORA");
    });

    $("#jea-lobophylia").click(function(){
        jea_lps("LOBOPHYLIA");
    });

    $("#jea-pectinia").click(function(){
        jea_lps("PECTINIA");
    });

    $("#jea-plate").click(function(){
        jea_lps("PLATE");
    });

    $("#jea-sun-coral").click(function(){
        jea_lps("SUNCORAL");
    });

// mushroom
    $("#jea-bounce").click(function(){
        jea_lps("BOUNCE");
    });

    $("#jea-discosoma").click(function(){
        jea_lps("DISCOSOMA");
    });

    $("#jea-jawbreaker").click(function(){
        jea_lps("JAWBREAKER");
    });

    $("#jea-rhodactis").click(function(){
        jea_lps("RHODACTIS");
    });

    $("#jea-ricordea").click(function(){
        jea_lps("RICORDEA");
    });

    $("#jea-yuma").click(function(){
        jea_lps("YUMA");
    });

// invertebrates
    $("#jea-clam").click(function(){
        jea_lps("CLAM");
    });

    $("#jea-crab").click(function(){
        jea_lps("CRAB");
    });

    $("#jea-seacucumber").click(function(){
        jea_lps("SEACUCUMBER");
    });

    $("#jea-snail").click(function(){
        jea_lps("SNAIL");
    });

    $("#jea-snail").click(function(){
        jea_lps("SNAIL");
    });

    $("#jea-worm").click(function(){
        jea_lps("WORM");
    });

// euphyllia
    // $("#jea-elegance").click(function(){
    //     jea_lps("ELEGANCE");
    // });

    $("#jea-frammer").click(function(){
        jea_lps("FRAMMER");
    });

    $("#jea-frogspawn").click(function(){
        jea_lps("FROGSPAWN");
    });

    $("#jea-hammer").click(function(){
        jea_lps("HAMMER");
    });

    $("#jea-torch").click(function(){
        jea_lps("TORCH");
    });

// soft coral
    $("#jea-carnation").click(function(){
        jea_lps("CARNATION");
    });

    $("#jea-cloves").click(function(){
        jea_lps("CLOVES");
    });

    $("#jea-gorgonian").click(function(){
        jea_lps("GORGONIAN");
    });

    $("#jea-softcoral").click(function(){
        jea_lps("SOFTCORAL");
    });

    $("#jea-sponge").click(function(){
        jea_lps("SPONGE");
    });

    $("#jea-toadstool").click(function(){
        jea_lps("TOADSTOOL");
    });

    $("#jea-tubipora").click(function(){
        jea_lps("TUBIPORA");
    });

// louis wonderland
    $("#jea-trachy").click(function(){
        jea_lps("TRACHY");
    });

    $("#jea-wellso").click(function(){
        jea_lps("WELLSO");
    });

// hilary meat
    $("#jea-acanthophyllia").click(function(){
        jea_lps("ACANTHOPHYLLIA");
    });

    $("#jea-cynarina").click(function(){
        jea_lps("CYNARINA");
    });

    $("#jea-indophyllia").click(function(){
        jea_lps("INDOPHYLLIA");
    });

// load more products PAGINATION
    // $("#jea-load-more").click(function(){
    //     console.log(next_url);
    //     load_more();
    // });

    // var el = document.getElementById("deliveryDate-jea");

    // if (el.addEventListener) {
    //     el.addEventListener("click", function() {
    //         alert("clicked");
    //     }, false);
    // }
    var scrolling = false;
    window.addEventListener('scroll',(Event)=>{
        // console.log('Scrolling');
        try {
            let buttonTop = $("#jea-load-more").offset().top;
            let buttonButtom = buttonTop + $("#jea-load-more").height();

            let windowTop = $(window).scrollTop();
            let windowButtom = windowTop + $(window).height();
            // console.log("WindowTop: "+windowTop);
            // console.log("windowButtom: "+windowButtom);
            // console.log("buttonTop: "+buttonTop);
            // console.log("buttonButtom: "+buttonButtom);
            if(buttonButtom <= windowButtom && buttonTop > windowTop){
                scrolling = true;
                // console.log("Scrolling: "+scrolling);
            }else{
                // console.log("no load more button");
            } 
        } catch (error) {
            //console.log(error.message);
        }
        
        

    },{passive:true});
    
    // let control = document.querySelector("#jeajea");
    // control.addEventListener('scroll', ()=>{
    //     scrolling = true;
    // },{passive:true});
    
    setInterval(async() => {
        if(scrolling){
            load_more();

            scrolling = false;
        }
    }, 300);
});
	
//FUNCTION AREA--------------------------------------
function jea_lps(productType) {
    //sort_by=created-descending
    $('html, body').animate({
        scrollTop: $(".collection-main").offset().top
    }, 1000);
    
    $.ajax({
        url: "/collections/types?q=" + productType + "&sort_by=created-descending",
        type: "GET",
        dataType: "html",
        beforeSend: function () {
            $("#newcat").text("LOADING...");
        }
    })
    .done(function (incoming_data) {
        var new_category = $(incoming_data).find(".collection-main");
        $(".collection-main").html(new_category.html());

        // var category_title = $(incoming_data).find("#jea-category-title");
        // console.log(category_title);
        // $("#jea-new-category-title").html(category_title.html());
        

        var title = $("#anemones option:selected").text();
        $("#new-cat-title").text("HELLO");

        products_on_page = $(incoming_data).find('.jea-product-on-page');
        next_url = products_on_page.data('next-url');
        
        console.log("NEXT URL:"+next_url);
        console.log('nagloading toh');

        // let urlPath = "/collections/types?q=" + productType + "&sort_by=created-descending";
        // window.history.pushState({"html":incoming_data.html,"pageTitle":incoming_data.pageTitle},"", urlPath);
    })
    .always(function(){
        var title = $("select option:selected").text();
        $("#newcat").text(title);
    });
}

//for loading more products per category
var i=0;
function load_more() {
    console.log("NEXT URL:"+next_url);
    // next_url = $('.jea-product-on-page').data('next-url');
    // console.log("NEXT URL:"+next_url);
    $.ajax({
        url: next_url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function () {
            $('.load-more__btn').hide();
            $('.load-more__spinner').show();
        }
    }).done(function (next_page) {
        $('.load-more__spinner').hide();

        let new_products = $(next_page).find('.jea-product-on-page');
        let new_url = new_products.data('next-url');
        i++;
        console.log("NEW URL:"+new_url+" "+i);
        if (new_url) {
            $('.load-more__btn').show();
        }else{
            $('#load-more__msg').show();
        }

        next_url = new_url;
        $(".jea-product-on-page").append(new_products.html());
    });
}
// ----/collections/types?page=2&q=RHODACTIS/
